import { Switch, SwitchProps } from '@mantine/core';
import classes from '@/components/StyledInputFields/Inputs.module.css';

const StyledSwitch = (props: SwitchProps) => {
  return <Switch {...props} classNames={{ label: classes.label }} withThumbIndicator={false} />;
};

export default StyledSwitch;
